// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3agb0","header":"Messages_header__3mviV"};